import { mdiAccountOutline, mdiCogOutline, mdiDnsOutline, mdiAbacus } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'

export default function useClientList() {
  const clients = ref([])
  const choices = ref({})

  const statusesFilter = ref([])
  const cityFilter = ref([])
  const tagsFilter = ref([])

  const tableColumns = [
    { text: 'name', value: 'name', class: 'ps-7 text-uppercase' },
    { text: 'status', value: 'status', class: 'text-uppercase' },
    { text: 'tags', value: 'tags', class: 'text-uppercase', sortable: false },
    { text: 'projectsAmount', value: 'projectsAmount', align: 'center', class: 'text-uppercase' },
    { text: 'positionAmount', value: 'positionsAmount', align: 'center', class: 'text-uppercase' },
    { text: 'workload', value: 'projectsWorkload', align: 'center', class: 'text-uppercase' },
    { text: 'city', value: 'city', class: 'text-uppercase' },
    {
      text: 'actions',
      value: 'actions',
      align: 'center',
      sortable: false,
      class: 'text-uppercase',
    },
  ]

  const searchQuery = ref('')
  const totalClientListTable = ref(0)
  const loading = ref(false)
  const options = ref({
    sortDesc: [true],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  })
  const userTotalLocal = ref([])
  const overview = ref([])

  const { getClients, getClientsFilterChoices, getClientsOverview } = useActions('staff', [
    'getClients',
    'getClientsFilterChoices',
    'getClientsOverview',
  ])

  const fetchClientsOverview = async () => {
    overview.value = await getClientsOverview()
  }

  // fetch data
  const fetchClients = async () => {
    loading.value = true
    const { data, success } = await getClients({
      status: statusesFilter.value,
      city: cityFilter.value,
      tags: tagsFilter.value,
      search: searchQuery.value,
      page: options.value.page,
      pageSize: options.value.itemsPerPage,
      ordering: options.value.sortBy.map((el, index) => {
        const parsedEl = el
          .replaceAll('.', '__')
          .replace('projectsAmount', 'projects_amount')
          .replace('positionsAmount', 'positions_amount')
          .replace('projectsWorkload', 'projects_workload')

        return `${options.value.sortDesc[index] ? '-' : ''}${parsedEl}`
      }),
    })
    if (success) {
      if (Object.hasOwnProperty.bind(data)('results') && Object.hasOwnProperty.bind(data)('count')) {
        clients.value = data.results
        totalClientListTable.value = data.count
      } else {
        clients.value = data
        totalClientListTable.value = data.length
      }
      loading.value = false
    }
    choices.value = await getClientsFilterChoices({
      status: statusesFilter.value,
      city: cityFilter.value,
      tags: tagsFilter.value,
      search: searchQuery.value,
    })
  }

  const timer = ref(null)
  const delaySearchHandler = async () => {
    clearTimeout(timer.value)
    timer.value = setTimeout(async () => {
      await fetchClients()
    }, 1000)
  }

  watch([statusesFilter, cityFilter, tagsFilter, options], async () => {
    await fetchClients()
  })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveClientTotalIcon = (title) => {
    if (title === 'total') return { icon: mdiCogOutline, color: 'secondary' }
    if (title === 'position amount') return { icon: mdiDnsOutline, color: 'primary' }
    if (title === 'taken assignees') return { icon: mdiAccountOutline, color: 'success' }
    if (title === 'demand') return { icon: mdiAbacus, color: 'success' }

    return { icon: mdiAccountOutline, color: 'primary' }
  }

  return {
    fetchClientsOverview,
    fetchClients,
    resolveClientTotalIcon,
    delaySearchHandler,

    tableColumns,
    searchQuery,
    totalClientListTable,
    loading,
    options,
    userTotalLocal,
    overview,
    clients,
    choices,
    statusesFilter,
    cityFilter,
    tagsFilter,
  }
}
